// What the user is doing right now beyond "which page": AI chat open, a
// document being processed, a recording in progress, an upload, a fax match.
// Feature code calls beginActivity/endActivity; the presence pinger reports
// the current set with every ping.
const active = new Map();
const subscribers = new Set();

function notify() {
  const list = getActivities();
  subscribers.forEach((fn) => {
    try { fn(list); } catch (_) { /* a subscriber error must not break the caller */ }
  });
}

export function beginActivity(name, detail = null) {
  if (!name) return;
  const had = active.has(name);
  active.set(name, detail);
  if (!had) notify();
}

export function endActivity(name) {
  if (active.delete(name)) notify();
}

export function getActivities() {
  return Array.from(active.keys());
}

export function subscribeActivities(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

export function _resetActivitiesForTests() {
  active.clear();
  subscribers.clear();
}
